import React from 'react';

const Skeleton: React.FC<{
  width?: number;
  height?: number;
  className?: string;
}> = ({ width, height = 20, className }) => (
  <div
    className={`${className ? className : ''}`}
    style={{ width: width ?? '100%', height, backgroundColor: '#e8e8e8' }}
  ></div>
);

export default Skeleton;
